export default __webpack_public_path__ + "static/media/TriggerRestApi.1f542d71.svg";